import styled from 'styled-components';
import {justifyStart} from '../../../../../globalVariables/GlobalFlex';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const validationRow = styled.div`
    ${dFlexCenter};
    ${justifyStart};
    gap: var(--space-2xl);
    font-size: var(--font-size-button-category);
    color: var(--color-text-default);
    line-height: var(--line-height-caption);
`;

export const validationItem = styled.div`
    ${dFlexCenter};
    gap: var(--space-md);
`;

export const validationLabel = styled.span`
`;

export const checkOff = styled.span`
    display: inline-block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 50%;
    background: var(--primitive-gray-300);
`;

